import { render, staticRenderFns } from "./ReturnCard.vue?vue&type=template&id=7319a446&scoped=true"
import script from "./ReturnCard.vue?vue&type=script&lang=js"
export * from "./ReturnCard.vue?vue&type=script&lang=js"
import style0 from "./ReturnCard.vue?vue&type=style&index=0&id=7319a446&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319a446",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7319a446')) {
      api.createRecord('7319a446', component.options)
    } else {
      api.reload('7319a446', component.options)
    }
    module.hot.accept("./ReturnCard.vue?vue&type=template&id=7319a446&scoped=true", function () {
      api.rerender('7319a446', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/cardHandling/components/ReturnCard.vue"
export default component.exports